import { z } from 'zod';

export const AhqFindOpportunitySchema = z.object({
  opportunityId: z.string().uuid(),
});
export type AhqFindOpportunity = z.infer<typeof AhqFindOpportunitySchema>;
